module.exports = __webpack_public_path__ + "static/media/beach.a40530b2.jpg";